import { render, staticRenderFns } from "./modal-profile-update-password.vue?vue&type=template&id=09dfe9ac"
import script from "./modal-profile-update-password.vue?vue&type=script&lang=js"
export * from "./modal-profile-update-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports